module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page case-study expro",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "landing"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/Our_Solution.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/expro-excercise-text.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/expro-image.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Leveraging the active presence of fitness enthusiasts on various social media channels, we started building the ExPRO \ncommunity on Facebook and Instagram. We not just introduced the various events through these channels, but deep-dived into what ExPRO is offering through them. While announcing the impressive lineup of 40+ international Presenters, \nconversations were created around the various topics of Seminars like GroupEx sessions, Animal Flow, innovations in HIIT, diet and dietary restrictions, yoga, fitness needs of special populations and so on. The presence of every fitness brand at the \nConvention was announced and celebrated, connecting with their specific audiences. ")]), _vm._v(" "), _c('p', [_vm._v("As these conversations started garnering attention, we created more excitement by bringing the focus on the Dance Party celebrities and Presenters of Seminars. This generated organic engagement and united the followers of multiple \nprofessionals in a single community. As the excitement soared, several fitness celebrities and brands created and shared \nexclusive content for ExPRO. This active social community and our digital amplification efforts helped in making ExPRO 2019 being perceived as a not-to-be-missed fitness convention for every fitness enthusiast.")]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, [_c('slide', [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/g1.jpg")
    }
  })]), _vm._v(" "), _c('slide', [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/g2.jpg")
    }
  })]), _vm._v(" "), _c('slide', [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/g3.jpg")
    }
  })]), _vm._v(" "), _c('slide', [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/g4.jpg")
    }
  })]), _vm._v(" "), _c('slide', [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/g5.jpg")
    }
  })])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('router-link', {
    staticClass: "more",
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', [_vm._v("More Case Studies →")])])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/The_Challenge.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12 cross"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#000",
      "color": "#fff"
    }
  }, [_c('p', [_vm._v("ExPRO by Fitness SG is one of the largest fitness conventions in South-East ASIA.Happening at Suntec Singapore,ExPRO 2019 featured a plethora of events like Seminars, Convention, Dance Party, Kettlebell Championships, ExPRO Strength Challenge and multiple Networking events.")]), _vm._v(" "), _c('p', [_vm._v("The challenge was to attract and enhuage multiple audiences ranging from exercise professionals, athletes, entrepreneurs in the fitness industry to fitness enthusiasts. We were tasked with building and managing a community of people who are passionate about fitness and increase the number of registrations for multiple events at ExPRO 2029.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('img', {
    staticClass: "wide-img",
    attrs: {
      "src": require("../img/Challenge_Img.jpg")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/The_Results.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {}, [_c('img', {
    staticClass: "wide-img",
    attrs: {
      "src": require("../img/expro-result-image.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-371e1652"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExproCaseStudy.vue
// module id = 159
// module chunks = 0